import {Component, Input, ContentChild} from '@angular/core';
import {WizardOnTabActive} from "./wizard.tab.lifecycle";

@Component({
    selector: 'wizard-content',
    template: require('./wizard.content.template.html')
})
export class WizardContent {

    @Input('for') public tabId: string;
    @ContentChild(WizardOnTabActive) listener: WizardOnTabActive;

    public contentActive: boolean = false;

    public setContentState(state: boolean) {
        this.contentActive = state;

        if (!!this.listener && state) {
            this.listener.activate(this.tabId);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/wizard/wizard.content.ts